// 烏茲別克
export default {
    dialog: {
        msgShow: "Habarnoma",
        buttonOk: 'Ha',
        buttonCancel: 'Bekor qilish',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'Yopish'
    },
    employeeNumber: 'Texnik hodim ID',
    pleaseEnterEmployeeNumber: 'Texnik hodim ID kiriting',
    password: 'Parol',
    pleaseEnterPassword: 'Parol kiriting',
    login: 'Kirish',
    required: 'Shart',
    synchronize: 'Sinxron',
    salesOrder: 'Xizmat hisoboti',
    pleaseEnterHome: 'Mijoz nomi va xizmat hisobotini kiriting',
    searchFilter: 'Qidiruv & Filtr',
    machineSpecifications: 'Rusum & Xususiyatlar',
    processingStatus: "Uskunani ta'mirlash holati",
    processing: null,
    finish: null,
    waitCountermeasures: null,
    reset: 'Orqaga',
    submit: "Jo'natildi",
    muMachineInvestigation: 'Umumiy holat va samaradorlik',
    logout: 'Chiqish',
    searchDate: 'Qidiruv sanasi',
    time: 'Qidiruv soati',
    basicInformation: "Mijoz haqida ma'lumot",
    addSalesOrder: "Xizmat hisoboti qo'shish",
    save: 'Saqlash',
    date: 'Sana',
    pleaseSelectDate: 'Sana belgilang',
    travelNumber: 'Xizmat hisobot fayli',
    pleaseEnterTravelNumber: 'Xizmat hisobot raqamini kiriting',
    customerCode: 'Mijoz kodi',
    pleaseEnterCustomerCode: 'Mijoz kodini kiriting',
    customerName: 'Mijoz nomi',
    pleaseEnterCustomerName: 'Mijoz nomini kiriting',
    country: "O'lka",
    pleaseEnterCountry: "O'lkani kiriting",
    customerAddress: 'Mijoz manzili',
    pleaseEnterAddress: 'Mijoz manzilini kiriting',
    customerContact: 'Mijozning vakolatli shaxsi',
    pleaseEnterContact: "Vakolatli shaxs ma'lumotlarini kiriting",
    salesRepresentative: "Sotuvdan mas'ul shaxs",
    pleaseEnterSalesRepresentative: "Sotuvdan mas'ul shaxsni ma'lumotlarini kiriting",
    hint: 'Habarnoma',
    createDate: 'Barpo qilingan sana',
    salesOrderNumber: 'Xizmat hisobotnoma raqami',
    customerSatisfaction: 'Mijozning mamnunligi',
    maintenancePersonnel: 'Texnik hodim',
    maintenanceTime: 'Xizmat berilgan vaqt',
    customerConfirmation: "Mijoz tasdig'i",
    copy: 'Nusxalash',
    delete: "O'chirish",
    recordTime: null,
    machineNumber: 'Uskunaning seriya raqami',
    copyToSalesOrder: "Xizmat fayliga qo'shish",
    copyTo: "Ko'chirish",
    selectSalesOrderNumber: 'Xizmat faylini tanlang',
    pleaseEnterSalesOrderNumber: 'Xizmat hisobotnoma raqamini kiriting',
    latitudeAndLongitude: 'Kenglik va uzunlik',
    startMaintenance: 'Xizmatni boshlash',
    endMaintenance: 'Xizmatni tugatish',
    newMachine: "O'rnatish hisobotnomasi",
    maintenance: 'Uskunani tuzatish',
    addMachineServiceOrder: null,
    selectType: 'Turini tanlash',
    generalMaintenance: "Umumiy ko'rik",
    oilEducationTraining: 'Moylash mashqi',
    pleaseEnterMachineNumber: 'Uskuna raqamini kiriting',
    manufacturingDate: 'Ishlab chiqarilgan sana',
    pleaseSelectManufacturingDate: 'Ishlab chiqarilgan sanani tanlang',
    maintenanceWarranty: 'Kafolat muddati (1 yil)',
    underWarranty: 'Kafolat muddatidagi xizmat',
    warrantyExpired: 'Kafolat muddatidan oshgan xizmat',
    confirm: "Ho'p",
    cancel: 'Bekor qilish',
    addMaintenancePersonnel: 'Texnik hodim ismini kiriting',
    maintenanceTimeTotal: null,
    day: 'Kun',
    hour: 'Soat',
    enterFactory: 'Xizmatni boshlash',
    pleaseSelectEnterFactory: 'Iltimos, xizmatni boshlating',
    longitude: 'Uzunlik',
    // pleaseEnterLongitude: 'Kenglik kiriting',
    latitude: 'Kenglik',
    // pleaseEnterLatitude: 'Uzunlik kiriting',
    leaveFactory: 'Xizmatni tugatish',
    pleaseSelectLeaveFactory: 'Iltimos, xizmatni tugating',
    duration: 'Xizmat muddati',
    pleaseEnter: 'Iltimos, kiriting',
    selectTime: 'Sana va soatni tanlang',
    selectSatisfaction: 'Mijozning mamnunligi',
    verySatisfied: 'Juda mamnun',
    satisfied: 'Mamnun',
    ordinary: 'Yetarli darajada',
    dissatisfied: 'Mamnun emas',
    veryDissatisfied: null,
    opinionReply: 'Mijozning izohi',
    takePhoto: 'Rasmga olish',
    uploadFile: 'Faylga yuklash',
    audio: 'Ovozli habar',
    video: 'Video habar',
    electronicSignature: 'Mijozning imzosi',
    signatureDate: 'Imzo sanasi',
    clear: "O'chirish",
    machineInformation: "Uskuna ma'lumoti",
    machineFunction: 'Uskuna funksiyasini tekshirish',
    organizationArrangement: 'Temirning tuzilishi & naqshi',
    spareParts: 'Ehtiyot qismlari',
    operationProcedure: "Texnik hodim sinovdan o'tkazish sharhi",
    problemHandling: 'Muammoni aniqlash',
    trainee: "Ta'lim oluvchi",
    coursePlan: "Ta'lim rejasi",
    courseSchedule: "Ta'lim dasturi",
    inputVoltageAndCurrent: 'Voltaj va oqimni yozing',
    lowSpeed: 'Past tezlik',
    highSpeed: 'Baland tezlik',
    accelerationDecelerationSlope: 'Tezlashish/Sekinlashish',
    acceleration: 'Tezlashish',
    deceleration: 'Sekinlashish',
    clothRoller: 'Pastki zarba tizimni sozlash',
    left: 'Chap',
    center: "O'rta",
    right: "O'ng",
    yarnFeedingTeeth: "Tishli g'ildirak",
    saddleRingDistance: "Havo bo'shlig'i",
    yarnNozzleNumber: 'Ip tashuvchi moslama soni',
    height: 'Ip tashuvchi & Qopqoq ignasining orasidagi masofa',
    spacing: 'Ip tashuvchi&Silindr ignasining orasidagi masofa',
    warpYarnInfo: 'Hom mato',
    inch: 'Inch',
    cm: 'Sm',
    timeSequence: 'Vaqt',
    needle: 'Ignalar',
    yarnSpecification: 'Ip xususiyatlari',
    yarn: 'Ip',
    serialNumber: 'Boshqa uskunalarning seriya raqami',
    technician: 'Texnik hodim',
    series: "Ma'to partiyasi",
    fabricType: "Ma'to turi",
    productFeatures: 'Maxsulotning xususiyatlari',
    inputVoltage: 'Voltaj kiriting',
    inputCurrent: 'Oqimni kiriting',
    electronicWindingTensionUpper: 'Elektron chizma tizimining kuchlanishi (Yuqori)',
    electronicWindingTensionLower: 'Elektron chizma tizimining kuchlanishi (Past)',
    mechanicalType: 'Mexanik tortishish tizimining uzatgich holati*',
    lowerNeedleDistanceToSeatRing: "Platina ustuni havo bo'shlig'i",
    upperNeedleDistanceToSeatRing: "Silindr qopqog'i havo bo'shlig'i",
    upperNeedleDistanceToLowerNeedleNozzle: 'Qopqoq va silindr orasidagi masofa',
    selectorNeedleRingDistanceToTakeUpPlate: "Silindr ushlagichi va rama orasidagi havo bo'shlig'i",
    seatRingDistanceToTakeUpPlate: "Silindr ushlagichi havo bo'shlig'i",
    machineSpeed: 'Rpm',
    inverterFrequency: 'Hz',
    yarnCount: 'Ilmoq soni',
    gramsPerSquareMeter: 'gr/m2',
    yardsPerPound: 'gr/yd',
    customerYarnWidth: 'En',
    customerSpecifiedYarnLength: 'Ip uzunligi',
    newCustomerPackageTiming: 'Platina vaqti',
    doubleSidedCuttingTiming: "Qopqoq po'lat vaqti",
    nozzleTiming: 'Ip tashuvchi vaqti',
    yarnCode: 'Ip kodi',
    yarnType: 'Ipning xususiyati',
    color: 'Ip rangi',
    yarnSize: 'Ip raqami',
    fiberCount: 'Tola soni',
    innerFiber: 'Ichkariga taxlash',
    outerFiber: 'Tashqariga taxlash',
    flatness: 'Tekislik',
    roundness: 'Yumaloqlik',
    windPressure: 'Havo bosimi',
    appearance: "Ko'rinishi",
    machineLevel: 'Uskuna Gavda muvozanati',
    trident: "Silindr qopqog'ining muvozanati",
    highLegWinder: 'Baland oyoqli uskunaning ostki tortish tizimi',
    fabricSlitting: 'Ochiq en uskunaning ostki tortish tizimi',
    inverterCurrent: 'Invertor oqimi',
    machineFunctionFrame: 'Memminger & Doira & Chordoq',
    inchStart: "Sekin ishni boshla va to'xtat",
    firstSecondSpeed: 'Tezlik,yoruglik ve parrak sozlamalari',
    firstSecondSpeed2: 'Tezlik sozlamalari',
    controllerOtherFunctions: 'Ekranning boshqa xususiyatlari',
    electricalBoxSignals: 'Signal & Sensor',
    fanDustRemovalAction: 'Parrak ishlashi',
    oilSprayerAction: "Yog'lama ishlashi",
    airBlowerSystemAction: 'Havoning bosimi va ishlashi',
    windingAction: 'Ostki tortish tizimi ishlashi',
    machineControllerOperationTutorial: 'Tekshiruv ekrani haqida bilimini olish',
    machineOperationTutorial: 'Uskunani ishlatish bilimini olish',
    other: 'Boshqa xususiyatlar',
    descriptionAndAttachment: 'Tavsifnoma',
    upperNeedleArrangement: null,
    upperKnifeArrangement: null,
    lowerNeedleArrangement: 'Silindr- igna joylashuvi',
    lowerNeedleArrangementShort: null,
    lowerKnifeArrangement: null,
    lowerKnifeArrangementShort: null,
    upperNeedlePlate: "Silindr qopqog'i",
    lowerNeedleCylinder: 'Silindr',
    blank: "Havo bo'shlig'i",
    blockRule: 'Qotirish',
    retractionBaseline: 'Platina-igna orasidagi masofa',
    upperPlateNeedleWithdrawalKnob: 'Qopqoqni iz shkalasi',
    upperPlateNeedleWithdrawalDepth: "Silindr qopqog'i - Iz shkalasi sozlamasi",
    upperPlateHalfNeedleHeight: 'Kapak Örgü ve Fank Çeliği İlmek Uzunluğu Ayarı',
    upperPlateFlatNeedleHeight: 'Kapak İptal Çeliği İlmek Uzunluğu Ayarı',
    lowerCylinderFlatNeedleHeight: 'Silindir İptal Çeliği İlmek Uzunluğu Ayarı',
    lowerCylinderFlatNeedleDepth: 'Silindir Kovanı May Ayarı',
    lowerCylinderNeedleWithdrawalKnob: 'Silindrni iz shkalasi',
    yarnTypeCode: 'Ip kodi',
    yarnTypeTensionN: 'Ip tarangligi (N)',
    cmPer100Needles: 'Ip uzunligi (100 ignada)',
    feedYarnLengthPerRevolution: 'Ip uzunligi (1 ilishda)',
    aluminumPlateYarnFeedingDepthCm: 'Doiraning diametri (sm)',
    yarnFeedingAluminumPlateScale: "Doiraning o'lchami",
    newCustomerPackage: 'Platina',
    upperPlate: 'Qopqoq',
    lowerCylinder: 'Silindr',
    yarnShort: 'Ip',
    pleaseEnterProductName: 'Qismlar izohini kiriting',
    pleaseEnterProductNumber: null,
    quantity: 'Dona',
    damage: 'Singan',
    missing: 'Kam',
    wrong: "Noto'g'ri",
    pleaseEnterTitle: 'Sarlovha kiriting',
    pleaseEnterContent: 'Tarkibni kiriting',
    addQuestionItem: "Savol qo'shish",
    questionProcessingRecord: 'Xizmat yechimini saqlash',
    pleaseEnterQuestionDescription: 'Muammo izohini qoldiring',
    traineeAndClient: null,
    trainer: "O'rgatgan shaxs",
    drawingFunction: 'CAD chizmasi',
    upperMachineProgram: 'Uskuna dasturi',
    UnravelingFunction: "Ma'to tahlili",
    courseName: "Ta'lim nomi",
    pleaseEnterCourseName: "Ta'lim nomini kiriting",
    imageName: 'Naqsh nomi',
    pleaseEnterImageName: 'Naqsh nomini kiriting',
    confirmItem: 'Tasdiqlash',
    undone: 'Tamomlanmagan',
    pleaseEnterInquire: 'Mijoz nomini kiriting, MU raqami',
    machineUtilizationSurvey: 'Mijozning ishi va uskunadan foydalanish darajasi',
    customerID: 'Mijoz ID',
    pleaseEnterCustomerID: 'Mijoz ID kiriting',
    pleaseSelect: 'Iltimos tanlang',
    pleaseEnterSkill: 'Iltimos, qobiliyatni kiriting',
    pleaseEnterBuyer: 'Iltimos, oluvchini kiriting',
    pleaseEnterRemark: 'Iltimos, izoh kiriting',
    source: 'Manbaa',
    selfInput: '自行輸入',
    textileEquipment: "To'quv uskunasi",
    textileMachineBrand: "To'quv uskunasi rusumi",
    textileMachineType: "To'quv uskunasi modeli",
    notSelected: 'Tanlanmadi',
    select: 'Tanlandi',
    brand: 'Brend',
    totalMachine: null,
    openRate: null,
    dailyOutput: null,
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: 'Iltimos, sozlash tarkibini kiriting',
    // alert
    editNotSave: "O'zgartirishlarni saqlamagan holda chiqishni xohlayotganingizdan aminmisiz?",
    deleteConfirm: "O'chirishni xohlayotganingizdan aminmisiz?",
    confirmClearSignature: "Imzo bilan bog'liq ma'lumotlarni olib tashlamoqchimisiz?",
    confirmWriteData: "Ma'lumot yozilishini tasdiqlaysizmi?",
    confirmCopyToSalesOrder: "Ma'lumotlarni ushbu hisobotnomaga ko'chirishni rostdan xohlaysizmi?",
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: "O'chirildi.",
    clearSuccess: 'Olib tashlandi.',
    copySuccess: 'Nusxalash tugallandi.',
    selectWorker: 'Iltimos, mutaxassisni tanlang.',
    selectProblem: 'Iltimos, savol elementini tanlang.',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: 'Sana tanlang',
    yarnTensionN: 'Ip tarangligi (N)',
    category: 'Tur',
    kind: 'Rusum',
    // pleaseSelectType: 'Turini tanlash',
    dateInOutError: "Xizmatni tugatish sanasi har doim xizmat ko'rsatishning boshlanish sanasiga teng yoki undan kechroq bo'lishi kerak.",
    yarnFeedingTeethOrDisc: "Tishli g'ildirak",
    changed: "O'zgarganlar",
    pleaseSelectSparePartsStatus: 'Iltimos, aksessuar holatini tanlang.',
    pleaseEnterDuration: null,

    // API語系
    saveComplete: 'Muvaffaqiyatli saqlandi',
    needOnline: 'Need Online.',
    addComplete: "Muvaffaqiyatli qo'shildi",
    reportCreator: 'Hisobot yaratuvchisi',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: '同步異常',
    synchronizeSuccess: 'Sinxronlash muvaffaqiyatli bajarildi',
    downloadFail: '下載異常',
    downloadSuccess: 'Muvaffaqiyatli yuklandi',
    synchronizeSelect: 'Tanlovni sinxronlash',
    onlySynchronizeOffData: null,
    synchronizeData: null,
    synchronizeImage: 'Tasvirni sinxronlash',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: "Oflayn ma'lumotlarni yuklab oling",
    downloadOfflineImage: 'Oflayn tasvirni yuklab oling',
    synchronizing: 'Sinxronlanmoqda, iltimos kuting. Ilova ekranini yopmang.',
    downloading: 'Yuklab olinmoqda,iltimos kuting. Ilova ekranini yopmang.',
    confirmDownload: 'Yuklashni tasdiqlaysizmi?',
    confirmSynchronization: 'Sinxronizatsiyani tasdiqlaysizmi?',
    overwriteOffline : "Yuklab olish joriy oflayn ma'lumotlarni qayta yozadi.",
    synchronizationOnline: "Sinxronizatsiya onlayn bilan bog'liq ma'lumotlarni sinxronlashtiradi.",
    uploadFail: '上傳異常',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: "Yaratish tartibi bo'yicha sozlang",
    sortByType: "Turi bo'yicha tartibga soling",
    reportDownload: 'hisobot',
    selectServiceReport: 'Xizmat hisobotini tanlang',
    enterServiceReportOrMachine: null,
    selectAll: 'Hammasini tanlang',

    downloadHint:null
}
